import styles from "./BlogCard.module.css"
import { BlogCardProps } from "../../../types/card.types";
/**
* A card with image, title and description.
*
* @param props BlogCard props
* @param {number} props.id - Post id
* @param {string} props.title - Post title
* @param {string} props.description - Post description
* @param {string} props.imageSrc - Post banner image
* @param {string} props.className - Optional additional class
* @returns TSX.Element
*/
const BlogCard = ({id, title, imageSrc, description, className} : BlogCardProps) => {

    return(
        <>
            <div className={`${styles.BlogCard} ${className ? className : ""}`} key={id}>
                <div className={styles.BlogCardImage} style={{backgroundImage: `url(${imageSrc})`}}></div>
                <div className={styles.BlogCardContent}>
                    <p className={styles.BlogCardTitle}>{title}</p>
                    <p className={styles.BlogCardDescription}>{description}</p>
                </div>
            </div>
        </>
    )
}
export default BlogCard